import { callApiToServer } from '../callApi';

export async function collectionReport(
    authtoken,
    salesObject,
    skip,
    limit
) {
    try {
        let header = {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            "authorization": "Berear " + authtoken
        };

        let body = JSON.stringify(salesObject);

        let endUrl = `v1/auth/sales/collected-report/${skip}/${limit}`;

        let responseData = await callApiToServer(body, header, "POST", endUrl);

        return responseData;

    } catch (err) {
        throw err;
    }
}
